<template>
  <label class="input" :class="[{'input_full':full, 'input_password':password}, `input_${type}`]">
    <span class="input__main">
      <input
        @input="emitInput"
        @change="emitInput"
        :value="value"
        :placeholder="placeholder"
        :id="id"
        ref="input"
        type="text"
        class="input__target"
      />
    </span>
    <span class="input__side">
      <span class="input__error">
        {{errorMessage}}
      </span>
    </span>
  </label>
</template>

<script>
  export default {
    name: 'Input',
    props: {
      id: {
        type: String,
        required: false
      },
      password: {
        type: Boolean,
        required: false
      },
      full: {
        type: Boolean,
        required: false
      },
      placeholder: {
        type: String,
        required: false
      },
      type: {
        type: String,
        required: false,
        default: 'text'
      },
      errorMessage: {
        type: String,
        required: false
      },
      maxLength: {
        required: false,
        default: null
      },
      value: {
        required: true
      }
    },
    methods: {
      emitInput () {
        if (this.maxLength) {
          this.$refs.input.value = this.$refs.input.value.slice(0, this.maxLength)
        }

        if (this.type === 'number') {
          this.$refs.input.value = this.$refs.input.value.replace(/\D/g, '')
        }

        this.$emit('input', this.$refs.input.value)
      }
    }
  }
</script>
